var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standard-container',{attrs:{"title":"Error","description":"","icon":"mdi-error"}},[_vm._v(" Errore generico ")])}
var staticRenderFns = []

export { render, staticRenderFns }